const stats = [
  { value: "2", label: "iOS Products Launched" },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-28 md:py-36 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden h-[420px] md:h-[520px]">
              <img
                src="https://public.readdy.ai/ai/img_res/ccc466ed980ac1988987f1807d81a8e9.jpg"
                alt="KIRCI DOO team at work"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
            </div>

          </div>

          {/* Right: Content */}
          <div>
            <span className="text-xs uppercase tracking-[0.25em] text-gray-400 font-medium">Who We Are</span>
            <h2 className="text-4xl md:text-5xl font-light text-gray-900 mt-3 mb-6 leading-tight tracking-tight">
              Expert Team Behind<br />iOS Innovation
            </h2>
            <div className="w-12 h-px bg-gray-200 mb-8" />

            <p className="text-gray-600 text-base leading-relaxed mb-5">
              KIRCI DOO is a dedicated team of iOS specialists, security engineers, and UX designers united by a single mission: to build applications that genuinely improve people&apos;s digital lives. Founded with a passion for the Apple ecosystem, we craft every product with precision and care.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-10">
              Our expertise spans mobile security, performance optimization, and intuitive interface design. We believe that great software should be both powerful and effortless — and that&apos;s exactly what we deliver with every release.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="border-l-2 border-gray-100 pl-4">
                  <p className="text-2xl font-semibold text-gray-900">{stat.value}</p>
                  <p className="text-xs text-gray-400 mt-1 uppercase tracking-wider">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
